<template>
  <div>
    <el-form :model="form" ref="form" label-position="" label-width="150px" size="mini" style="" >
      <el-form-item label="姓名" style="width: 100%" required >
        <el-input v-model="form.name"  />
      </el-form-item>
      <el-form-item label="校区" style="width: 100%"  required>
        <el-select v-model="campusList" multiple placeholder="请选择" size="medium">
          <el-option
              v-for="item in campus"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属部门"  required>
        <el-select v-model="form.departmentId" clearable filterable placeholder="请选择所属部门" size="medium">
          <el-option
              v-for="item in college"
              :key="item.value"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="证件号" style="width: 100%" required>
        <el-input v-model="form.identityId"/>
      </el-form-item>
      <el-form-item label="手机号" style="width: 100%" required >
        <el-input v-model="form.phone"/>
      </el-form-item>
      <el-form-item label="车牌号" style="width: 100%"  >
        <el-input v-model="form.cph"/>
      </el-form-item>
      <el-form-item label="通行有效期" required>
        <el-date-picker
            v-model="form.accessTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            clearable
            :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-form-item>
      <el-row gutter="24">
        <el-col span="8">
          <el-form-item label="人脸" style="width: 100%" required>
            <el-upload
                ref="fileUpload"
                :limit="Number(1)"
                v-model="form.photoPath"
                :action="upUrl"
                list-type="picture-card"
                :headers="fileUploadHeaders"
                :on-change="handleChange"
                :on-remove="onPhotoRemove"
                :on-success="handlerPhotoUploadSuccess"
                :on-preview="handlePicturePreview"
                :before-upload = "beforePhotoUpload"
                :show-file-list="true"
                :file-list="upFileList"
                :class="{hide:photoUploadCard}"
            >
              <i class="el-icon-plus" />
            </el-upload>
            <el-dialog :visible.sync="imgShow" title="图片详情" top="1vh" width="800px" append-to-body="true">
              <img width="100%" :src="imgSrc" alt="">
            </el-dialog>
          </el-form-item>
        </el-col>
        <el-col span="8">
          <el-form-item label="无犯罪记录证明" style="width: 100%" required>
            <el-upload
                ref="fileUpload"
                :limit="Number(1)"
                v-model="form.certificatePath"
                :action="upUrl2"
                list-type="picture-card"
                :headers="fileUploadHeaders"
                :on-change="handleChange"
                :on-remove="onPhotoRemove2"
                :on-success="handlerPhotoUploadSuccess2"
                :on-preview="handlePicturePreview2"
                :show-file-list="true"
                :file-list="upFileList2"
                :class="{hide:photoUploadCard2}"
            >
              <i class="el-icon-plus" />
            </el-upload>
            <el-dialog :visible.sync="imgShow2" title="图片详情" top="1vh" width="800px" append-to-body="true">
              <img width="100%" :src="imgSrc2" alt="">
            </el-dialog>
          </el-form-item>
        </el-col>
        <el-col span="8">
          <el-form-item label="聘用合同" style="width: 100%" required>
            <el-upload
                ref="fileUpload"
                :limit="Number(1)"
                v-model="form.contractPath"
                :action="upUrl3"
                list-type="picture-card"
                :headers="fileUploadHeaders"
                :on-change="handleChange"
                :on-remove="onPhotoRemove3"
                :on-success="handlerPhotoUploadSuccess3"
                :on-preview="handlePicturePreview3"
                :show-file-list="true"
                :file-list="upFileList3"
                :class="{hide:photoUploadCard3}"
            >
              <i class="el-icon-plus" />
            </el-upload>
            <el-dialog :visible.sync="imgShow3" title="图片详情" top="1vh" width="800px" append-to-body="true">
              <img width="100%" :src="imgSrc3" alt="">
            </el-dialog>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注">
        <el-input v-model="form.remark"/>
      </el-form-item>
      <!--        <el-form-item label="经度" style="width: 100%" required >-->
      <!--          <el-input v-model="form.longitude">-->
      <!--            <el-button slot="append" icon="el-icon-search" @click="scanIdAdd"></el-button>-->
      <!--          </el-input>-->
      <!--        </el-form-item>-->
      <!--        <el-form-item label="维度" style="width: 100%" required >-->
      <!--          <el-input v-model="form.latitude">-->
      <!--            <el-button slot="append" icon="el-icon-search" @click="scanIdAdd"></el-button>-->
      <!--          </el-input>-->
      <!--        </el-form-item>-->
      <!--        <el-form-item label="偏差半径(米)" style="width: 100%"  >-->
      <!--          <el-input-number v-model="form.deviationRadius" @change="handleChange" :min="1" :max="100" label="偏差半径"></el-input-number>-->
      <!--        </el-form-item>-->
      <div style="text-align: right">
        <el-button type="primary" style="" @click="doSubmit">提交</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import request from '@/utils/apiRequest'
import PointMap from "@serviceapp/businessManage/patrolManage/patrolPointManage/PointMap.vue";
import {selectCollege} from "../personInfo/api";
export default {
  props: {
    width: {
      type: String,
      default: '80%'
    },
    visible: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: {}
    },
    showZgxx: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      campus: [{
        value: '崂山校区',
        label: '崂山校区'
      }, {
        value: '四方校区',
        label: '四方校区'
      }],
      campusList: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      upUrl: process.env.VUE_APP_BASE_API + '/user/commonUserRequest/uploadImage',
      upUrl2: process.env.VUE_APP_BASE_API + '/user/commonUserRequest/uploadCertificate',
      upUrl3: process.env.VUE_APP_BASE_API + '/user/commonUserRequest/uploadContract',
      fileUploadHeaders: {
        "Authorization": 'bearer ' + sessionStorage.getItem("access_token")
      },
      uploadedFilePath: [],
      upFileList: [],
      imgSrc: '',
      imgShow: false,
      photoUploadCard: false,
      //无犯罪证明
      uploadedFilePath2: [],
      upFileList2: [],
      imgSrc2: '',
      imgShow2: false,
      photoUploadCard2: false,
      //聘用合同
      uploadedFilePath3: [],
      upFileList3: [],
      imgSrc3: '',
      imgShow3: false,
      photoUploadCard3: false,
      flowList:[],
      college:[],
    };
  },
  mounted(){
    // this.fetchData()
    this.selectCollege()
  },
  watch: {
    // form: {
    //   handler(newValue, oldValue) {
    //     newValue.upFileList = [];
    //     this.uploadedFilePath = [];
    //     if (newValue.dangerPhotos != null && newValue.dangerPhotos !== '') {
    //       const path = newValue.dangerPhotos.split(',');
    //       path.forEach(item => {
    //         newValue.upFileList.push({name:item, url:process.env.VUE_APP_BASE_API + '/user' + item})
    //         this.uploadedFilePath.push(item)
    //       })
    //     }
    //   },
    //   deep: true
    // }
  },
  methods: {
    selectCollege(){
      selectCollege()
          .then((res) =>{
            this.college = res.data.data
          })
    },
    doSubmit() {
      if (this.form.accessTime != null && this.form.accessTime.length == 2) {
        this.form.accessStartTime = this.form.accessTime[0]+' 00:00:00'
        this.form.accessEndTime = this.form.accessTime[1]+' 23:59:59'
      }
      this.form.photoPath = this.uploadedFilePath.join(',')
      this.form.certificatePath = this.uploadedFilePath2.join(',')
      this.form.contractPath = this.uploadedFilePath3.join(',')
      if(this.campusList!=null){
        this.form.campus = this.campusList.join(',')
      }
      this.form.type = 2
      request({
        url: '/user/commonUserRequest/addRequest',
        data: this.form,
        method: 'post',
        loading: true
      }).then(res => {
        this.$message.success('操作成功')
        this.form = {}
        delete this.form.accessTime
        this.upFileList = []
        this.upFileList2 = []
        this.upFileList3 = []
        this.uploadedFilePath = []
        this.uploadedFilePath2 = []
        this.uploadedFilePath3 = []
        this.$emit('closeDialog')
      })
    },
    beforePhotoUpload(file) {
      if(file.type!=='image/jpeg' && file.type!=='image/jpg'){
        this.$message.error('上传人脸图片只能是 JPG 或 JPEG 格式!');
        return false;
      }
      if(!(file.size / 1024  < 200 && file.size / 1024  > 10)){
        this.$message.error('上传人脸图片大小只能10-200KB!');
        return false;
      }
    },
    // 处理照片上传成功
    handlePicturePreview(file) {
      this.imgSrc = file.url
      this.imgShow = true
    },
    handlerPhotoUploadSuccess(response, file, fileList) {
      file.name = response.data
      this.uploadedFilePath.push(response.data)
      this.photoUploadCard = fileList.length >= 1
    },
    onPhotoRemove(file, fileList) {
      this.uploadedFilePath = this.uploadedFilePath.filter(item => item !== file.name)
      this.photoUploadCard = fileList.length >= 1
      console.log(file.name)
    },
    // 处理无犯罪记录证明
    handlePicturePreview2(file) {
      this.imgSrc2 = file.url
      this.imgShow2 = true
    },
    handlerPhotoUploadSuccess2(response, file, fileList) {
      file.name = response.data
      this.uploadedFilePath2.push(response.data)
      this.photoUploadCard2 = fileList.length >= 1
    },
    onPhotoRemove2(file, fileList) {
      this.uploadedFilePath2 = this.uploadedFilePath2.filter(item => item !== file.name)
      this.photoUploadCard2 = fileList.length >= 1
      console.log(file.name)
    },
    // 处理聘用合同
    handlePicturePreview3(file) {
      this.imgSrc3 = file.url
      this.imgShow3 = true
    },
    handlerPhotoUploadSuccess3(response, file, fileList) {
      file.name = response.data
      this.uploadedFilePath3.push(response.data)
      this.photoUploadCard3 = fileList.length >= 1
    },
    onPhotoRemove3(file, fileList) {
      this.uploadedFilePath3 = this.uploadedFilePath3.filter(item => item !== file.name)
      this.photoUploadCard3 = fileList.length >= 1
      console.log(file.name)
    },
    handleFormatError(file) {
      this.upFileList = [];
      this.$message.warning({
        background: true,
        title: '文件格式不正确',
        content: '文件 ' + file.name + ' 格式不正确，请上传.xls,.xlsx文件。'
      })
    },
    handleMaxSize(file) {
      this.$message.warning({
        title: '文件超出大小限制',
        background: true,
        content: '文件 ' + file.name + '大小超出限制，最大支持200KB'
      })
      this.upFileList = [];
    },


  },


  components: {
    PointMap

  }

};
</script>
<style>
.hide .el-upload--picture-card {
  display: none;
}
</style>
